













































import { Component, Emit, Vue } from 'vue-property-decorator';
import { vpnService } from '@/services/VpnService';
import * as FileSaver from 'file-saver';

@Component({
  props: ['uuid'],
})
export default class VpnUserDownload extends Vue {
  @Emit()
  onClose() {
    return;
  }
  isLoading = false;
  password = '';
  errors = [];
  regionId = 0;
  vpnUserData = {};
  isActivePassValidation = false;
  wrongPass = false;

  mounted() {
    this.regionId = parseInt(this.$route.params.regionId, 10);
    vpnService.getVpnClientData(this.$props.uuid).then((data: any) => {
      this.vpnUserData = data;
    });
  }

  downloadVpnClient(os: string) {
    this.isActivePassValidation = true;
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    vpnService
      .downloadVpnClient(this.$props.uuid, this.password, os, true)
      .then(response => {
        this.isLoading = false;
        let filename: any = response.headers['content-disposition'].match(/filename="([^"]+)"/i);
        filename = !!filename && filename[1] ? filename[1] : 'unknown.bin';
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        FileSaver.saveAs(blob, filename);
      })
      .catch((data: any) => {
        if (data && data.data && data.status === 401) {
          if (data.data.errors === 'unauthorized') {
            this.wrongPass = true;
          }
        }
        this.isLoading = false;
      });
  }
}
